import { render, staticRenderFns } from "./UpdateUserEmailPage.vue?vue&type=template&id=4a50d5e9&scoped=true&"
import script from "./UpdateUserEmailPage.vue?vue&type=script&lang=ts&"
export * from "./UpdateUserEmailPage.vue?vue&type=script&lang=ts&"
import style0 from "./UpdateUserEmailPage.vue?vue&type=style&index=0&id=4a50d5e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50d5e9",
  null
  
)

export default component.exports